(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('MusicSheet', MusicSheet);

    MusicSheet.$inject = ['$resource', 'DateUtils'];

    function MusicSheet ($resource, DateUtils) {
        var resourceUrl =  'api/music-sheets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.editionDate = DateUtils.convertLocalDateFromServer(data.editionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.editionDate = DateUtils.convertLocalDateToServer(copy.editionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.editionDate = DateUtils.convertLocalDateToServer(copy.editionDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
